// ==== Version 1 — Branded access-denied state for protected routes
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../components/BrandLogo";
import Seo from "../components/Seo";
import "./AccessDenied.css";

export default function AccessDenied() {
  const heading = useRef(null);
  useEffect(() => { heading.current?.focus(); }, []);

  return (
    <>
      <Seo title="Access denied | Blessed with a Kiss" description="This account does not have permission to view this page." noindex />
      <section className="bwak-access-denied" aria-labelledby="access-denied-title">
        <div className="bwak-access-denied__card">
          <BrandLogo size={56} decorative framed style={{ margin: "0 auto 16px" }} />
          <p className="bwak-access-denied__code">403</p>
          <h1 id="access-denied-title" ref={heading} tabIndex={-1}>Access denied</h1>
          <p>This account does not have permission to view this page.</p>
          <Link className="bwak-access-denied__home" to="/">Go to homepage</Link>
        </div>
      </section>
    </>
  );
}
